import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { fromStoreResultToStore } from "../../../../../pages/BookAppointment/adapters/v3/pages/BookAppointment/adapters/from-store-result-to-store.js";
import StoreFinderItemContainer from "../../../../StoreFinder/StoreFinderItem/v3/components/StoreFinder/StoreFinderItem/StoreFinderItemContainer.js";
const PreferredStoreTile = ({ className, store, onClick }) => /* @__PURE__ */ React.createElement(
  StoreFinderItemContainer,
  {
    className: classnames("appointments-preferred-store-tile", className),
    store: {
      ...fromStoreResultToStore(store),
      wheelchairAccessible: false,
      hearingAppointmentPossible: false
    },
    variant: "list-item",
    icon: /* @__PURE__ */ React.createElement(Icon, { name: "store", width: 32, height: 32 }),
    onClick
  }
);
export {
  PreferredStoreTile as default
};
//# sourceMappingURL=PreferredStoreTile.js.map
